var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 22,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7C8 5.89543 8.89543 5 10 5H22C23.1046 5 24 5.89543 24 7V19C24 20.1046 23.1046 21 22 21H10C8.89543 21 8 20.1046 8 19V7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.68 7.02C19.08 6.82 17.62 6.72 16.02 6.72C14.36 6.72 12.92 6.8 11.34 7.02C10.86 7.08 10.58 7.36 10.58 7.78V17.14C10.58 17.44 10.8 17.64 11 17.7L11.6 17.8V19.06C11.6 19.2 11.72 19.3 11.88 19.3H12.84C12.96 19.3 13.08 19.2 13.08 19.06V17.94C13.86 18.04 14.92 18.08 15.98 18.08C17.06 18.08 18.16 18.04 18.92 17.94V19.06C18.92 19.2 19.06 19.3 19.18 19.3H20.14C20.3 19.3 20.42 19.2 20.42 19.06V17.8L21.02 17.7C21.24 17.64 21.44 17.46 21.44 17.14V7.78C21.44 7.36 21.16 7.08 20.68 7.02ZM20.58 14.26C20.58 14.52 20.48 14.66 20.16 14.7C19.02 14.9 17.52 15.1 16.06 15.1C14.52 15.1 13.06 14.92 11.9 14.66C11.58 14.6 11.46 14.48 11.46 14.22V8.38C11.46 8.12 11.58 7.94 11.9 7.94L20.16 7.98C20.48 7.98 20.58 8.16 20.58 8.42V14.26ZM12.32 16.84C12.02 16.82 11.78 16.58 11.78 16.3C11.8 16.04 12.04 15.8 12.32 15.8C12.6 15.8 12.84 16.04 12.84 16.3C12.84 16.6 12.6 16.84 12.32 16.84ZM19.62 16.84C19.34 16.82 19.1 16.58 19.1 16.3C19.12 16.04 19.36 15.8 19.62 15.8C19.9 15.8 20.14 16.04 20.14 16.3C20.14 16.6 19.9 16.84 19.62 16.84Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopBus);
export default __webpack_public_path__ + "static/media/stop-bus.6e1c0d70408fea79132fa094c00001cf.svg";
export { ForwardRef as ReactComponent };